<template>
  <AppHeaderLogo :to="localePath({ name: 'dashboard', params: { dashboard: dashboardMode } })" />

  <template v-if="!route.meta?.hideNavigation">
    <div class="hidden lg:flex items-center lg:gap-x-12">
      <AppHeaderHostNav />
    </div>

    <div class="flex items-center gap-x-4">
      <NuxtLink
        :to="localePath({ name: 'index' })"
        class="text-sm/6 font-semibold text-primary-950  rounded-full py-2.5 px-4 transition-colors duration-300 ease-in-out hover:bg-gray-50"
      >
        {{ t('switchToTravelling') }}
      </NuxtLink>

      <NuxtLink
        v-if="userExists"
        :to="localePath({ name: 'profile-id', params: { id: userId }, query: { cta: 'header-nav-avatar' } })"
       
        class="leading-none"
      >
        <TAvatar
          :src="userAvatar"
          :text="userExists ? userInitials : undefined"
          size="lg"
        />
      </NuxtLink>

      <TMenu
        :show-badge="menuBadge"
       
      >
        <div class="py-1">
          <TMenuItem
            :to="localePath({ name: 'dashboard', params: { dashboard: dashboardMode } })"
            :text="t('pageLink.dashboard')"
            icon="home"
           
            weight="medium"
            class="lg:hidden"
            :badge-amount="dashboardNotificationsTotal"
          />

          <TMenuItem
            :to="localePath({ name: 'dashboard-calendar', params: { dashboard: dashboardMode } })"
            :text="t('pageLink.calendar')"
            icon="calendar"
            weight="medium"
            class="lg:hidden"
          />

          <TMenuItem
            :to="localePath({ name: 'dashboard-messages', params: { dashboard: dashboardMode } })"
            :text="t('pageLink.inbox')"
            icon="comment"
            weight="medium"
            class="lg:hidden"
           
            :badge-amount="inboxNotificationsTotal"
          />

          <TMenuItem
            :to="localePath({ name: 'dashboard-insights', params: { dashboard: dashboardMode } })"
            :text="t('pageLink.insights')"
            icon="chart-mixed-up-circle-dollar"
            weight="medium"
            class="lg:hidden"
            :badge-amount="isSuspended ? 1 : opportunitiesNotificationsGrouped"
          />

          <TMenuItem
            :to="localePath({ name: 'dashboard-bookings-index', params: { dashboard: dashboardMode } })"
            :text="t('pageLink.bookings')"
            icon="book-open"
            weight="medium"
           
          />
        </div>

        <div class="py-1">
          <AppHeaderMenuListAnRv />
        </div>

        <div class="py-1">
          <TMenuItem
            :to="localePath({ name: 'dashboard-profile', params: { dashboard: dashboardMode } })"
            :text="t('pageLink.account')"
            icon="gear"
            :show-badge="!userIsVerified || !userPhoneNumber"
           
          />

          <TMenuItem
            :to="t('helpCenter.url')"
            :text="t('helpCenter.title')"
            icon="message-question"
            @click="handleTrackHelpCenterClicked"
          />
        </div>

        <div class="py-1">
          <TMenuItem
            :text="t('actions.logOut')"
           
            @click.prevent="logOut()"
          />
        </div>

        <div
          v-if="userIsAdmin"
          class="py-1"
        >
          <div class="px-4 mt-2 text-xs font-semibold text-gray-500 uppercase tracking-widest mb-1">
            Admin
          </div>

          <TMenuItem
            :to="runtimeConfig.public.apps.operationsDashboard.baseURL"
            external
            text="Operations"
          />
        </div>
      </TMenu>
    </div>
  </template>
</template>

<script setup lang="ts">
const route = useRoute()
const { dashboardMode } = useBaseName()
const localePath = useLocalePath()
const { t } = useI18n()
const runtimeConfig = useRuntimeConfig()
const { logOut } = useAuthentication()
const {
  userInitials,
  userAvatar,
  userId,
  userExists,
  userPhoneNumber,
  userIsAdmin,
  userIsVerified,
} = useUser()
const {
  dashboardNotificationsTotal,
  inboxNotificationsTotal,
  isSuspended,
  opportunitiesNotificationsGrouped,
} = useNotificationsData()

const { hydrationStatus } = useHydrationState()
const { isMdBreakpoint, isLgBreakpoint } = useBreakpoint()
const menuBadge = computed(() => {
  if (!hydrationStatus.value) {
    return false
  }

  const notifications = (isMdBreakpoint.value && !isLgBreakpoint.value)
    ? dashboardNotificationsTotal.value > 0 || inboxNotificationsTotal.value > 0 || isSuspended.value
    : false

  return notifications || (userExists.value && (!userIsVerified.value || !userPhoneNumber.value))
})

const { pageSource } = usePageSource()
function handleTrackHelpCenterClicked() {
  trackHelpCenterClicked({
    pageSource: pageSource.value,
  })
}
</script>

<i18n src="~~/i18n/locales/common/app.json" lang="json" />
